module.exports = __webpack_public_path__ + "media/images/maximize-b024a6f97259ca9ba45c916bb4207890fba69bdc5e475379a627dc4ce8a800fd.svg";